import bboostSvg   from 'assets/images/chips/bboost-120.svg'
import freehitSvg  from 'assets/images/chips/freehit-120.svg'
import wildcardSvg from 'assets/images/chips/wildcard-120.svg'
import tripleSvg   from 'assets/images/chips/3xc-120.svg'

export type ChipType = 'bboost' | 'freehit' | 'wildcard' | '3xc'

export interface Chip {
  chip: ChipType,
  count: number
}

export type ChipRow = {
  id: string
  chip: string | null
  chipLabel: string
  count: number
}

export const CHIP_LABEL: Record<ChipType, string> = {
  bboost:   'Bench Boost',
  freehit:  'Free Hit',
  wildcard: 'Wildcard',
  '3xc':    'Triple Captain',
}

export const CHIP_ICON: Record<ChipType, string> = {
  bboost:   bboostSvg,
  freehit:  freehitSvg,
  wildcard: wildcardSvg,
  '3xc':    tripleSvg,
}